export default __webpack_public_path__ + "static/media/sleep.c10cec36.svg";